import {City} from '@/models/City'
import {Model} from '@/models/Model'
import {DataPromotionsArray} from '@/models/Promotion'
import {DataArray, DataResource, FilterSet} from '@/models/Response'
import Helper from '../services/Helper.js'


export class District extends Model {
  declare id: number | null
  created_at: Date | null
  updated_at: Date | null
  name: string | null
  lat: number | null
  lng: number | null

  city: City | null
  getResourceURL(): string {
    return Helper.setting.district.getResourceAPI
  }

}

export class DataDistrictsArray extends DataArray {

  declare data: District[]
  filter: FilterDistrict = new FilterDistrict()
}


export class FilterDistrict {
  price_group: FilterSet = new FilterSet()
}


export class DataDistrict extends DataResource {

  declare data: District

}
